import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/Dekoraciya.module.scss'

import { Container, Image } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'
import GreenButton from './GreenButton'
import FeedbackForm from './FeedbackForm'
import ClientOnlyFsLightbox from './ClientOnlyFsLightbox'

class Dekoraciya extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      show_feedback: false,
      lightboxController: {
        toggler: false,
        slide: 1
      }
    }
  }

  showFeedback = () => {
    this.setState({ show_feedback: true });
  }
  
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  openLightbox = (index) => {
    this.setState({
      lightboxController: {
        toggler: !this.state.lightboxController.toggler,
        slide: index + 1
      }
    })
  }

  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {

    const { data } = this.props,
    { show_feedback, lightboxController } = this.state

    return (
      <section className={`${styles.section}`}>
        <Container>
          {data?.title != '' &&
            <WhiteBlockTitle
              title={data?.title || ``}
            />
          }
          
          {/* Lightbox компонент */}
          <ClientOnlyFsLightbox
            toggler={lightboxController.toggler}
            sources={data?.images || []}
            slide={lightboxController.slide}
          />

          <div className={styles.content}>
            {data?.images.map( ( src, k ) => (
              <Image 
                className={`d-none d-lg-block`} 
                src={src} 
                width={226} 
                height={210} 
                alt={`${data?.title2} - ${k + 1}`}
                onClick={() => this.openLightbox(k)}
                style={{cursor: 'pointer'}}
              />
            ))}
            <div className={styles.content_rb}>
              <div className={styles.content_rb_topline}>
                <div className={styles.content_rb_title} dangerouslySetInnerHTML={{__html: data?.title2}} />
                <div>[01]</div>
              </div>
              <div className={styles.content_rb_text} dangerouslySetInnerHTML={{__html: data?.text}} />
              <div className={`${styles.content_rb_mobimg} d-lg-none`}>
                {data?.images.map( ( src, k ) => (
                  <Image 
                    src={src} 
                    width={226} 
                    height={210} 
                    alt={`${data?.title2} - ${k + 1}`}
                    onClick={() => this.openLightbox(k)}
                    style={{cursor: 'pointer'}}
                  />
                ))}
              </div>
              <GreenButton
                text={`Узнать подробнее`}
                width={420}
                action={() => this.showFeedback()}
                className={styles.content_rb_button}
              />
              <FeedbackForm
                title={`Декорация вашей лестницы`}
                text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
                btn={`Отправить`}
                data={[]}
                show={show_feedback}
                handleClose={() => this.closeFeedback()}
              />
            </div>
          </div>
        </Container>
      </section>
    )
  }
}

Dekoraciya.propTypes = {
  data: PropTypes.object
}

Dekoraciya.defaultProps = {
  data: {}
}

export default Dekoraciya